import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

export const contactNewsletterListContacts = {
  show: ({
    contactSqid,
    params = {},
  }: {
    contactSqid: string;
    params?: Params;
  }) =>
    buildPath(
      `/internal_api/contacts/${contactSqid}/newsletter_list_contacts`,
      params,
    ),

  update: ({
    contactSqid,
    params = {},
  }: {
    contactSqid: string;
    params?: Params;
  }) =>
    buildPath(
      `/internal_api/contacts/${contactSqid}/newsletter_list_contacts`,
      params,
    ),
};
